module.exports = __webpack_public_path__ + "img/toyota.6890f236.png";